import sanitizeHtml from 'sanitize-html';
import { SANITIZE_RICH_TEXT_CONFIG } from '@/config/sanitizeConfig';

// marks a string as HTML that has already been through sanitizeRichText -
// safe to pass to html-react-parser or dangerouslySetInnerHTML, unlike a plain string
export type SanitizedHtml = string & { readonly __brand: 'SanitizedHtml' };

// OE API sends line breaks as a literal `<CRLF>` token in several text fields -
// replace before sanitization so they survive as <br /> tags
const replaceCrlfWithBr = (text: string): string => {
  const replacedText = text.replace(/<CRLF>/g, '<br />');
  return replacedText.replace(/^\s*<br\s*\/?>/, '');
};

const sanitizeRichText = (text: string | null): SanitizedHtml | null => {
  if (!text) return null;
  return sanitizeHtml(replaceCrlfWithBr(text), SANITIZE_RICH_TEXT_CONFIG) as SanitizedHtml;
};

// strips all tags to plain text — for contexts that must not contain markup
// (e.g. JSON-LD fields), not for display rendering
const toPlainText = (html: string | null | undefined): string => {
  if (!html) return '';
  return html
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

export const HTMLService = {
  sanitizeRichText,
  toPlainText,
};
